import apiService from './apiService'
import AppConstants from '../appConstants'

class FlashService {
  getFlashFeed({ page = 1, limit = 10, commodity = 0, originCode } = {}) {
    const params = new URLSearchParams()
    params.append('page', page)
    params.append('limit', limit)
    params.append('reduced', true)
    params.append('commodity', commodity)
    if (originCode) params.append('originCode', originCode)
    params.append('flashFeed', true)

    return apiService.get(AppConstants.URL_LIST_REPORT_ALL, params)
  }
}

export default new FlashService()
